import { canUseDOM } from 'exenv';
import get from 'lodash/get';
import extend from 'lodash/extend';
import authUtil from '../../utils/auth_util';
import cachingService from '../../services/caching_service';
import request from '../../utils/request_util';
import Base from '../base_model';
import log from '../../services/logger_service';

export default class MagazineLatestIssuePostsModel extends Base {
  static fetch(params, store) {
    const state = store.getState();
    // const site = get(state, 'config.site');
    const cacheEnabled = get(state, 'config.cacheEnabled');
    const cacheNamespace = get(state, 'config.cacheNamespace');
    const cacheExpire = get(state, 'config.cacheExpire');
    const host = get(state, 'config.apiEndpoint') || 'fc-api.fastcompany.com';
    const protocol = get(state, 'config.protocol') || 'https://';
    const options = {};
    // api has auth in beta
    if (get(state, 'config.authEnabled')) {
      extend(options, authUtil(state));
    }

    const cacheKeyUrl = `${protocol}${host}/api/v1/magazine/get-magazine-latest-issue-posts`;

    const cacheKey = `${cacheNamespace}:${cacheKeyUrl}`;

    if (!cacheEnabled) {
      return request.getAsync(cacheKeyUrl, options);
    }

    return cachingService.getAsync(cacheKey).then(function fromCache(cacheRes) {
      if (cacheRes) {
        return Promise.resolve(JSON.parse(cacheRes));
      }

      if (!canUseDOM) {
        log.info(`Requesting: ${cacheKeyUrl} from model.`);
      }
      return request
        .getAsync(cacheKeyUrl, options)
        .then(function fetchSuccess(resp) {
          cachingService.setex(cacheKey, cacheExpire, JSON.stringify(resp));
          return resp;
        });
    });
  }
}
